export enum ContentFlagContentType {
	STORY = 'story',
	EVENT = 'event',
	IMAGE = 'image',
	CITATION = 'citation',
}

export type ContentFlag = {
	guid: string;
	createdByGuid: string;
	reason: number;
	body: string | null;
	storyGuid: string | null;
	eventGuid: string | null;
	imageGuid: string | null;
	citationGuid: string | null;
};

export type ContentFlagReason = {
    // Use this ID to reference the flag when making API calls
	id: number;
	name: string;
    // Which content types this reason can be applied to
    story: boolean;
    event: boolean;
    image: boolean;
    citation: boolean;
};

export type ContentFlagCount = {
    reasonId: number;
    name: string;
    count: number;
	contentType: ContentFlagContentType;
  }